import React from 'react';
import styled from 'styled-components';

// Everything inside <Screen> is sized in `cqw` so the phone scales from any width.
const Frame = styled.div<{ $width: string }>`
  --w: ${props => props.$width};
  position: relative;
  flex-shrink: 0;
  width: var(--w);
  aspect-ratio: 0.482;
  border-radius: calc(var(--w) * 0.175);
  padding: calc(var(--w) * 0.012);
  background: linear-gradient(145deg, #8a8a90 0%, #3a3a3e 14%, #1c1c1f 45%, #2c2c30 80%, #9a9aa0 100%);
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.55),
    0 30px 60px -18px rgba(0, 0, 0, 0.5),
    0 70px 120px -40px rgba(0, 0, 0, 0.45);
`;

const SideButton = styled.span<{ $side: 'left' | 'right'; $top: number; $height: number }>`
  position: absolute;
  ${props => props.$side}: calc(var(--w) * -0.011);
  top: ${props => props.$top}%;
  height: ${props => props.$height}%;
  width: calc(var(--w) * 0.014);
  border-radius: 2px;
  background: linear-gradient(90deg, #4a4a4f, #8a8a90, #4a4a4f);
  z-index: -1;
`;

const Bezel = styled.div`
  width: 100%;
  height: 100%;
  border-radius: calc(var(--w) * 0.163);
  padding: calc(var(--w) * 0.026);
  background: #030303;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.07);
`;

const Screen = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: calc(var(--w) * 0.132);
  overflow: hidden;
  container-type: inline-size;
  background: #000;
  transform: translateZ(0);
  user-select: none;
`;

const Glare = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 50;
  background: linear-gradient(115deg, rgba(255, 255, 255, 0.07) 0%, rgba(255, 255, 255, 0) 32%);
`;

interface DeviceProps {
  width: string;
  children: React.ReactNode;
  screenRef?: React.Ref<HTMLDivElement>;
  className?: string;
}

const Device: React.FC<DeviceProps> = ({ width, children, screenRef, className }) => (
  <Frame $width={width} className={className}>
    <SideButton $side="left" $top={17} $height={4.5} />
    <SideButton $side="left" $top={25} $height={8} />
    <SideButton $side="left" $top={35} $height={8} />
    <SideButton $side="right" $top={27} $height={12} />
    <Bezel>
      <Screen ref={screenRef}>
        {children}
        <Glare />
      </Screen>
    </Bezel>
  </Frame>
);

export default Device;
